module.exports = __webpack_public_path__ + "img/loginBg.d5ab95ae.png";